module.exports = __webpack_public_path__ + "static/media/TheGuardian.a82a9634.png";